import LoadingCard from "../LoadingCard";
import Grid from "../Utils/Grid.styled";
import Stack from "../Utils/Stack.styled";
import PropTypes from "prop-types";

const SkeletonLoader = ({ size, grid }) => {
  const renderLoading = (id) => <LoadingCard key={id} />;

  return grid ? (
    <Grid>{Array.from(Array(size || 8)).map((_, i) => renderLoading(i))}</Grid>
  ) : (
    <Stack direction="column" height="fit-content" gap="16">
      {Array.from(Array(size || 8)).map((_, i) => renderLoading(i))}
    </Stack>
  );
};

SkeletonLoader.propTypes = {
  grid: PropTypes.number,
};

export default SkeletonLoader;
